import { Factory } from 'fishery'
import { v4 as uuidV4 } from 'uuid'
import { OpalApiResponseDocument } from '@opallabs/api'

type Blocks = OpalApiResponseDocument<'ReadBlocksBFFV1', 200>
type Block = Blocks['data'][number]

export const singleCollectionBlockFactory: Factory<Block> =
  Factory.define<Block>(
    ({ sequence }) =>
      ({
        category_type: null,
        created_at: '2025-01-01',
        description: null,
        effective_privacy: 'some_but_not_all',
        duration: 'P364D',
        id: uuidV4(),
        image_id: null,
        is_template: false,
        is_workspace_wide_template: false,
        owner: {
          id: uuidV4(),
          legacy_id: '30',
          full_name: 'Gaylene Treutel',
          avatar_url: null,
        },
        start_date: '2025-01-01',
        template_description: null,
        template_name: null,
        title: `Private Plan #${sequence}`,
        last_updated_date: '2025-11-01',
        child_view_id: uuidV4(),
        connectors: [],
      }) satisfies Block
  )

export const blocksFactory: Factory<Blocks> = Factory.define<Blocks>(() => {
  return { data: singleCollectionBlockFactory.buildList(2) } satisfies Blocks
})
